<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      桥头西站<br>
站点介绍<br>
车站位于位于重庆路和同富路交叉口，沿同富路呈南北方向敷设。车站设置有3个出入口， 其中 A 口为主要紧急出入口,B 口、C 口为备用紧急出入口，有盲道及垂直电梯通往站厅。A 口为往 左炮台东方向公交接驳口，D 口为往海上田园东方向公交接驳口。周边主要分布了伟创力福永厂区、 永威五金塑料厂、华盛昌科技园、宝威塑胶制品厂等多个工业区,是福永片区工业区集中区域<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:20	00:00	12号线	4分钟	8分钟<br>
海上田园东	06:31	23:11	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:21	00:00	12号线	8分钟	8分钟<br>
海上田园东	06:31	23:11	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
重庆路北侧、大族激光全球智造中心、深圳市升宇智能科技有限公司<br><br>
B出入口:<br>
重庆路北侧、伟创力员工宿舍、伟创力电子设备（深圳）有限公司、大族激光智能装备集团、鑫国邦物流园<br><br>
C出入口:<br>
同富路西侧、泽鑫航科技、宝威塑料制品厂、福永永和科目二驾驶证考场、嘉隆科技（深圳）有限公司<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 桥头西地铁站<br>
M251<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>